import React from "react";
import { Icon } from "@abb/abb-common-ux-react/components/Icon";
import { Status } from "../../models/sample/Status";
import { ICalculatedDetails } from "../../models/measurement/CalculatedDetails";
import * as CONSTANTS from "../../utilities/Constants";
import { Translation } from "react-i18next";
import {
  Button,
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  WithTooltip,
} from "@abb/abb-common-ux-react";
import _ from "lodash";
import { ABB_CARET_DOWN, ABB_CARET_UP } from "../../utilities/IconConstants";

interface ILandingprops {
  showInstrumentProperty?: (data: any) => void;
  showKeyedInProperty?: (data: any) => void;
  showCalculatedPropertyDetails?: (data: any) => void;
  changeGridView: () => void;
  sampleData: any;
  measurementDetails: any;
  keyedInDetailsData?: any;
  calculatedDetailsData?: ICalculatedDetails[];

  startInstrumentMeasurement: (event: any, instrumentId: string) => void;
  stopInstrumentMeasurement: (event: any, instrumentId: string) => void;
  resumeInstrumentMeasurement: (event: any, instrumentId: string) => void;
  remeasureInstrumentMeasurement: (event: any, instrumentId: string) => void;
  stopMeasurement?: boolean;
  pausedMeasurement?: boolean;
  lastEnteredValue?: any;
  activeTab: any;
  selectedPositionFromMeasuring?: any;
  reMeasureDirectionPositionCount: (
    instumentId: string,
    directionId: string,
    position: any,
    count: any
  ) => void;
  callApiOnTabChange: (tab: number) => void;
  onToggle: (position: any[]) => void;
}

interface ILandingState {
  activeTab: any;
  disableMeasured: boolean;
  disabledKeyedIn: boolean;
  disabledCalculated: boolean;
  activeDirectionIndx: { measurementId: string; activeDirection: string[] }[];
}

export default class MeasurementTable extends React.Component<
  ILandingprops,
  ILandingState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      activeTab: this.props.activeTab || [0],
      disableMeasured:
        this.props.measurementDetails?.instrumentDetails?.length > 0
          ? false
          : true,
      disabledKeyedIn: this.props.keyedInDetailsData?.length > 0 ? false : true,
      disabledCalculated:
        this.props.calculatedDetailsData?.length > 0 ? false : true,
      activeDirectionIndx: [],
    };
  }


  componentWillReceiveProps(
    nextProps: Readonly<ILandingprops>,
    nextContext: any
  ): void {
    if (nextProps !== this.props) {
      if (
        nextProps.measurementDetails &&
        nextProps.measurementDetails.instrumentDetails &&
        nextProps.measurementDetails.instrumentDetails.length
      ) {
        let activeDirectionIndx = (
          nextProps.measurementDetails.instrumentDetails || []
        ).map((el: any) => {
          let activeDirection: any = [];
          (el.allDirections || []).forEach((x: any) => {
            if ((el.readings || []).some((y: any) => y.directionId === x.id)) {
              activeDirection.push(x.id);
            }
          });
          return {
            measurementId: el.id,
            activeDirection,
          };
        });
        this.setState({
          activeTab: nextProps.activeTab,
          disableMeasured:
            nextProps.measurementDetails?.instrumentDetails?.length > 0
              ? false
              : true,
          disabledKeyedIn:
            nextProps.keyedInDetailsData?.length > 0 ? false : true,
          disabledCalculated:
            nextProps.calculatedDetailsData?.length > 0 ? false : true,
          activeDirectionIndx,
        });
      }
      if(nextProps.keyedInDetailsData && nextProps.keyedInDetailsData.length){
        this.setState({
          activeTab: nextProps.activeTab,
          disableMeasured:
            nextProps.measurementDetails?.instrumentDetails?.length > 0
              ? false
              : true,
          disabledKeyedIn:
            nextProps.keyedInDetailsData?.length > 0 ? false : true,
          disabledCalculated:
            nextProps.calculatedDetailsData?.length > 0 ? false : true,
        });
      }
      if(nextProps.calculatedDetailsData && nextProps.calculatedDetailsData.length){
        this.setState({
          activeTab: nextProps.activeTab,
          disableMeasured:
            nextProps.measurementDetails?.instrumentDetails?.length > 0
              ? false
              : true,
          disabledKeyedIn:
            nextProps.keyedInDetailsData?.length > 0 ? false : true,
          disabledCalculated:
            nextProps.calculatedDetailsData?.length > 0 ? false : true,
        });
      }
    }
  }

  componentDidMount(): void {
    if (
      this.props.measurementDetails &&
      this.props.measurementDetails.instrumentDetails &&
      this.props.measurementDetails.instrumentDetails.length
    ) {
      this.setState({
        activeDirectionIndx:
          this.props.measurementDetails.instrumentDetails.map((el: any) => {
            let activeDirection: any = [];
            (el.allDirections || []).forEach((x: any) => {
              if (
                (el.readings || []).some((y: any) => y.directionId === x.id)
              ) {
                activeDirection.push(x.id);
              }
            });
            return {
              measurementId: el.id,
              activeDirection,
            };
          }),
      });
    }
  }

  private onSetActiveDirectionIndx = (id: any, direction: string) => {
    const activeDirectionIndxData = [...this.state.activeDirectionIndx];
    const activeDirectionIndx =
      activeDirectionIndxData && activeDirectionIndxData.length
        ? activeDirectionIndxData.map((elements) => {
            if (
              elements.measurementId === id &&
              elements.activeDirection.includes(direction.toString().trim())
            ) {
              const index = elements.activeDirection.indexOf(direction);
              if (index > -1) {
                elements.activeDirection.splice(index, 1);
              }
            } else if(elements.measurementId === id &&
              !elements.activeDirection.includes(direction.toString().trim())) {
              elements.activeDirection.push(direction);
            }
            return elements;
          })
        : [{ measurementId: id, activeDirection: [direction] }];
    this.setState({
      activeDirectionIndx,
    });
  };

  render() {
    return (
      <Translation>
        {(t) => (
          <React.Fragment>
            <div className="col-12">
              <div className="row">
                <div className="col-4">
                </div>
                <div className="col-4">
                  <ToggleButtonGroup
                    className="text-center"
                    selected={this.props.activeTab}
                    // tslint:disable-next-line: jsx-no-lambda
                    onChange={(v) => this.props.onToggle(v)}
                    monochrome={true}
                    sizeClass="medium"
                  >
                    <ToggleButton
                      text={t(CONSTANTS.MEASURED)}
                      disabled={this.state.disableMeasured}
                    />
                    <ToggleButton
                      text={t(CONSTANTS.KEYED_IN)}
                      disabled={this.state.disabledKeyedIn}
                    />
                    <ToggleButton
                      text={t(CONSTANTS.CALCULATED)}
                      disabled={this.state.disabledCalculated}
                    />
                  </ToggleButtonGroup>
                </div>
                <div className="col-4"></div>
              </div>

              <div className="divider"></div>
              <div className="table-data-container">
                <table>
                  <thead>
                    <tr>
                      {/* LANDING GRID PAGE = FOR MEASURING STATUS */}
                      {this.props.activeTab.includes(0) && (
                        <React.Fragment>
                          {this.props.measurementDetails?.instrumentDetails
                            ?.length > 0 && // Measurement Instrument details
                            (
                              this.props.measurementDetails.instrumentDetails ||
                              []
                            ).map((item: any) => {
                              let inUseOtherSample = false;
                              if (
                                item.checkInstrumentInUse &&
                                this.props.sampleData &&
                                item.checkInstrumentInUse?.status ===
                                  "In Use" &&
                                this.props.sampleData.name !==
                                  item.checkInstrumentInUse.sampleName
                              ) {
                                inUseOtherSample = true;
                              }

                              if (
                                this.props.sampleData &&
                                this.props.sampleData.status &&
                                (this.props.sampleData.status.name ===
                                  Status.STOPPED ||
                                  this.props.sampleData.status.name ===
                                    Status.PAUSED)
                              ) {
                                inUseOtherSample = true;
                              }
                              if(item.status?.name === Status.COMPLETED &&
                                this.props.sampleData && 
                                this.props.sampleData.status.name === 
                                Status.MEASURED
                              ){
                                inUseOtherSample = true;
                              }
                              let tooltipText = ""
                              if(item.status?.name === Status.PENDING ||
                                item.status.name === Status.AVAILABLE){
                                  tooltipText = CONSTANTS.BUTTON_START;
                              } else if(item.status?.name === Status.INUSE){
                                  tooltipText = CONSTANTS.BUTTON_START;
                              } else if(item.status?.name === Status.MEASURING){
                                  tooltipText = CONSTANTS.BUTTON_STOP;
                              } else if(item.status?.name === Status.PAUSED ||
                                item.status.name === Status.STOPPED){
                                  tooltipText = CONSTANTS.BUTTON_REMEASURE;
                              } else if(item.status?.name === Status.COMPLETED){
                                  tooltipText = CONSTANTS.BUTTON_REMEASURE;
                              } else if(item.status?.name === Status.WAITING){
                                tooltipText = CONSTANTS.BUTTON_WAITING;
                              } else{
                                  tooltipText = CONSTANTS.BUTTON_REMEASURE;
                              }
                              return (
                                <th>
                                  <div
                                    className="measureItems cursor-pointer"
                                    onClick={(e: any) =>
                                      this.props.showInstrumentProperty(item)
                                    }
                                  >
                                    <button
                                      title={tooltipText}
                                      className="icon-button circle btn-40  m-0 float-left"
                                    >
                                      {(item.status?.name === Status.PENDING ||
                                        item.status?.name ===
                                          Status.AVAILABLE) && (
                                        <Icon
                                          name={item.iconStatus?.name}
                                          sizeClass="small"
                                          onClick={
                                            !inUseOtherSample &&
                                            ((e: any) =>
                                              this.props.startInstrumentMeasurement(
                                                e,
                                                item.id
                                              ))
                                          }
                                          className={
                                            inUseOtherSample
                                              ? "iconDisabled"
                                              : ""
                                          }
                                        />
                                      )}
                                      {item.status?.name === Status.INUSE && (
                                        <Icon
                                          name={item.iconStatus?.name}
                                          sizeClass="small"
                                          onClick={
                                            !inUseOtherSample &&
                                            ((e: any) =>
                                              this.props.startInstrumentMeasurement(
                                                e,
                                                item.id
                                              ))
                                          }
                                          className={
                                            inUseOtherSample
                                              ? "iconDisabled"
                                              : ""
                                          }
                                        />
                                      )}
                                      {item.status?.name ===
                                        Status.MEASURING && (
                                        <Icon
                                          name={item.iconStatus?.name}
                                          sizeClass="small"
                                          onClick={
                                            !inUseOtherSample &&
                                            ((e: any) =>
                                              this.props.stopInstrumentMeasurement(
                                                e,
                                                item.id
                                              ))
                                          }
                                          className={
                                            inUseOtherSample
                                              ? "iconDisabled"
                                              : ""
                                          }
                                        />
                                      )}
                                      {(item.status?.name === Status.PAUSED ||
                                        item.status.name ===
                                          Status.STOPPED) && (
                                        <Icon
                                          name={item.iconStatus?.name}
                                          sizeClass="small"
                                          onClick={
                                            !inUseOtherSample &&
                                            ((e: any) =>
                                              this.props.remeasureInstrumentMeasurement(
                                                e,
                                                item.id
                                              ))
                                          }
                                          className={
                                            inUseOtherSample
                                              ? "iconDisabled"
                                              : ""
                                          }
                                        />
                                      )}
                                      {item.status?.name ===
                                        Status.COMPLETED && (
                                        <Icon
                                          name={item.iconStatus?.name}
                                          sizeClass="small"
                                          onClick={
                                            !inUseOtherSample &&
                                            ((e: any) =>
                                              this.props.remeasureInstrumentMeasurement(
                                                e,
                                                item.id
                                              ))
                                          }
                                          className={
                                            inUseOtherSample
                                              ? "iconDisabled"
                                              : ""
                                          }
                                        />
                                      )}
                                    </button>
                                    <div className="details">
                                      <p className="title sidebar-ellipsis">{t(item.name)}</p>
                                      {inUseOtherSample ? (
                                        <p className="statusGray">
                                          {t(item.checkInstrumentInUse?.status)}{" "}
                                          {
                                            item.checkInstrumentInUse
                                              ?.sampleName
                                          }
                                        </p>
                                      ) : (
                                        <p className="statusGreen">
                                          {item.status.name ===
                                          Status.NOTMEASURED
                                            ? t(Status.AVAILABLE)
                                            : t(item.status.name)}
                                        </p>
                                      )}

                                      <p>
                                        {item.count.completedCounts} (
                                        {item.count.totalCounts})
                                      </p>
                                    </div>
                                    <progress
                                      value={item.count.completedCounts}
                                      max={item.count.totalCounts}
                                    >
                                      {item.completionPercentage}{" "}
                                    </progress>
                                  </div>
                                </th>
                              );
                            })}
                        </React.Fragment>
                      )}

                      {/* LANDING GRID PAGE = FOR keyedin STATUS */}
                      {this.props.activeTab.includes(1) && (
                        <div className="row measureItemContainer">
                          {this.props.keyedInDetailsData?.length > 0 && // Keyedin Instrument details
                            (this.props.keyedInDetailsData || []).map(
                              (item: any, index: number) => {
                                return (
                                  <th className="col-xl-4 col-lg-4 col-md-6 col-xs-6 no-padding">
                                    <div
                                      className="measureItems cursor-pointer"
                                      onClick={(e: any) =>
                                        this.props.showKeyedInProperty(item)
                                      }
                                    >
                                      <div className="row no-padding no-margin">
                                        <div className="col-8">
                                          <div className="details flex-calc">
                                            <WithTooltip>
                                              <p className="title ellipsis-text" style={{margin: "5px 10px 3px 0"}}>
                                                {t(item.keyedInDetails[0].name)}
                                              </p>
                                              <Tooltip>
                                                <p className="title-tooltip no-margin">{t(item.keyedInDetails[0].name)}</p>
                                              </Tooltip>
                                            </WithTooltip>
                                            { (item.keyedInDetails[0].counts && item.keyedInDetails[0].counts.length && item.keyedInDetails[0].counts[0].totalCounts === item.keyedInDetails[0].counts[0].completedCounts) || (item.keyedInDetails[0].status
                                              .name === Status.COMPLETED) ? (
                                              <p className="statusGreen">
                                                 {t(Status.COMPLETED)}
                                              </p>
                                            ) : item.keyedInDetails[0].status
                                              .name === Status.PENDING ? (
                                              <p className="statusGray">
                                                {t(Status.PENDING)}
                                              </p>
                                            ) : item.keyedInDetails[0].status
                                              .name === Status.INPROGRESS ? (
                                              <p className="statusGray">
                                               {t(Status.INPROGRESS)}
                                              </p>
                                            ) : item.keyedInDetails[0].status
                                            .name === Status.STOPPED ? (
                                            <p className="statusGray">
                                                {t(Status.STOPPED)}
                                            </p>) :<></>}
                                            <p>
                                              {
                                                item.keyedInDetails[0].counts[0]
                                                  .completedCounts
                                              }{" "}
                                              (
                                              {
                                                item.keyedInDetails[0].counts[0]
                                                  .totalCounts
                                              }
                                              )
                                            </p>
                                          </div>
                                        </div>
                                        <div className="col-4 no-padding">
                                          <p className="keyedin-subtitle ellipsis-text flex-calc">
                                            {this.props.lastEnteredValue.map(
                                              (element: any, j: number) => {
                                                if (
                                                  item.id ===
                                                  element.keyedInPropertyId
                                                ) {
                                                  return (
                                                    <WithTooltip>
                                                      <p className="ellipsis-text no-margin font-weight-600">
                                                        {element.lastEnteredValue}
                                                      </p>
                                                      <Tooltip>
                                                        <p className="title-tooltip no-margin">
                                                          {element.lastEnteredValue}
                                                        </p>
                                                      </Tooltip>
                                                    </WithTooltip>
                                                  );
                                                }
                                              }
                                            )}
                                            {item?.keyedInDetails[0]
                                              ?.propertyMean?.mean ? (
                                              <WithTooltip>
                                                <p className="ellipsis-text no-margin font-weight-600">
                                                  {" "}
                                                  (
                                                  {item.keyedInDetails[0]?.propertyMean?.mean.toFixed(
                                                    item.keyedInDetails[0]
                                                      .decimals
                                                  )}
                                                  ){" "}
                                                </p>
                                                <Tooltip>
                                                  <p className="title-tooltip no-margin font-weight-600">
                                                    {" "}
                                                    (
                                                    {item.keyedInDetails[0]?.propertyMean?.mean.toFixed(
                                                      item.keyedInDetails[0]
                                                        .decimals
                                                    )}
                                                    ){" "}
                                                  </p>
                                                </Tooltip>
                                              </WithTooltip>
                                            ) : (
                                              <p className="no-margin">
                                                {" "}
                                                {
                                                  CONSTANTS.NOTCONSIDEREDFORCALC
                                                }{" "}
                                              </p>
                                            )}
                                            {item.keyedInDetails[0]?.unit && (
                                              <p className="no-margin">
                                                {item.keyedInDetails[0]?.unit}
                                              </p>
                                            )}
                                          </p>
                                        </div>
                                        <progress
                                          value={
                                            item.keyedInDetails[0].counts[0]
                                              .completedCounts
                                          }
                                          max={
                                            item.keyedInDetails[0].counts[0]
                                              .totalCounts
                                          }
                                        >
                                          {
                                            item.keyedInDetails[0].counts[0]
                                              .completionPercentage
                                          }{" "}
                                        </progress>
                                      </div>
                                    </div>
                                  </th>
                                );
                              }
                            )}
                        </div>
                      )}

                      {/* LANDING GRID PAGE = FOR calculated STATUS */}
                      {this.props.activeTab.includes(2) && (
                        <div className="row measureItemContainer">
                          {this.props.calculatedDetailsData?.length > 0 && // calculated Instrument details
                            (this.props.calculatedDetailsData || []).map(
                              (item: any) => {
                                return (
                                  <th className="col-xl-4 col-lg-4 col-md-6 col-xs-6 no-padding">
                                    <div
                                      className="measureItems cursor-pointer"
                                      onClick={(e: any) =>
                                        this.props.showCalculatedPropertyDetails(
                                          item
                                        )
                                      }
                                    >
                                      <div className="row no-padding no-margin"><div className="col-8">
                                        <div className="details flex-calc">
                                        <WithTooltip>
                                          <p className="title ellipsis-text" style={{margin: "5px 10px 10px 0"}}>{t(item.name)}</p>
                                          <Tooltip>
                                            <p className="title-tooltip no-margin">{t(item.name)}</p>
                                          </Tooltip>
                                        </WithTooltip>
                                        {item.calculatedValues.length > 0 ? (
                                          <p className="statusGreen">
                                            {t(Status.COMPLETED)}
                                          </p>
                                        ) : (
                                          <p className="statusGray">
                                            {t(Status.PENDING)}
                                          </p>
                                        )}
                                        </div>
                                      </div>
                                      <div className="col-4 no-padding">
                                        <p className="subtitle ellipsis-text flex-calc">
                                          {item.calculatedValues.length
                                          ? (
                                          <WithTooltip>
                                          <p className="ellipsis-text font-weight-600 no-margin">({
                                            (item.calculatedValues.reduce(
                                                  (total: any, next: any) =>
                                                  total + next.value,
                                                  0
                                                ) / item.calculatedValues.length
                                                ).toFixed(item.decimals)
                                          })</p>
                                          <Tooltip>
                                            <p className="title-tooltip no-margin">({
                                            (item.calculatedValues.reduce(
                                                  (total: any, next: any) =>
                                                  total + next.value,
                                                  0
                                                ) / item.calculatedValues.length
                                                ).toFixed(item.decimals)
                                            })</p>
                                          </Tooltip>
                                          </WithTooltip>
                                          ) : (
                                          <p className="no-margin">
                                            {CONSTANTS.NOTCONSIDEREDFORCALC}
                                          </p>)
                                          }
                                          {item?.unit && (
                                            <p className="no-margin">{item?.unit}</p>
                                          )}
                                          </p>
                                      </div>
                                      {item.calculatedValues.length > 0 ? (
                                        <progress
                                          value={100}
                                          max={100}
                                        ></progress>
                                      ) : (
                                        <progress
                                          value={0}
                                          max={100}
                                        ></progress>
                                      )}
                                      </div>
                                    </div>
                                  </th>
                                );
                              }
                            )}
                        </div>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="instrumentStatus">
                      {this.props.activeTab.includes(0) && (
                        <React.Fragment>
                          {this.props.measurementDetails?.instrumentDetails
                            ?.length > 0 &&
                            (
                              this.props.measurementDetails.instrumentDetails ||
                              []
                            ).map((item: any) => {
                              let currentPositionObj: any = null;
                              if (
                                this.props.selectedPositionFromMeasuring &&
                                item.id ===
                                  this.props.selectedPositionFromMeasuring
                                    .instrumentId
                              ) {
                                currentPositionObj = item.positionCount.find(
                                  (el: any) => {
                                    return (
                                      Number(el.position) ===
                                      Number(
                                        this.props.selectedPositionFromMeasuring
                                          .position
                                      )
                                    );
                                  }
                                );
                              }
                              const PositionDetails =
                                item.readings && currentPositionObj
                                  ? item.readings.find(
                                      (elems: any) =>
                                        elems.position ===
                                        Number(
                                          currentPositionObj?.position ?? "0"
                                        )
                                    )
                                  : "";

                              return item.isAutoLine ? (
                                item.directionCounts.length ? (
                                  <td>
                                    <div className="py-2 px-3">
                                      {t(Status.COMPLETED)}
                                    </div>
                                    <div className="divider"></div>
                                  </td>
                                ) : (
                                  <td>
                                    <div className="py-2 px-3">
                                      {t(Status.MEASURING)}
                                    </div>
                                    <div className="divider"></div>
                                  </td>
                                )
                              ) : (
                                <td>
                                  {item.status.name === Status.MEASURING &&
                                  currentPositionObj ? (
                                    currentPositionObj && PositionDetails ? (
                                      <div className="py-2 px-3">
                                        {PositionDetails &&
                                        PositionDetails.positionName
                                          ? PositionDetails.positionName
                                          : "Position"}{" "}
                                        - {currentPositionObj.completedCounts}(
                                        {currentPositionObj.totalCounts})
                                      </div>
                                    ) : (
                                      <div className="py-2 px-3">
                                        {item.status.name}
                                      </div>
                                    )
                                  ) : (
                                    <div className="py-2 px-3">
                                      {t(item.status.name)}
                                    </div>
                                  )}
                                  <div className="divider"></div>
                                </td>
                              );
                            })}
                        </React.Fragment>
                      )}

                      {this.props.activeTab.includes(1) && (
                        <React.Fragment>
                          {this.props.keyedInDetailsData?.keyedInDetails
                            ?.length > 0 && // keyedIn details
                            (
                              this.props.keyedInDetailsData.keyedInDetails || []
                            ).map((item: any, index: any) => {
                              return (
                                <td>
                                  <div className="py-2 px-3"></div>
                                  <div className="divider"></div>
                                </td>
                              );
                            })}
                        </React.Fragment>
                      )}
                    </tr>

                    <tr className="features">
                      {this.props.activeTab.includes(0) && (
                        <React.Fragment>
                          {this.props.measurementDetails?.instrumentDetails
                            ?.length > 0 && // Measurement Instrument details
                            (
                              this.props.measurementDetails.instrumentDetails ||
                              []
                            ).map((element: any, i: any) => {
                              let filteredArray: any = [];
                              if (element.isAutoLine) {
                                const grouped = _.mapValues(
                                  _.groupBy(element.readings, "propertyId")
                                );
                                for (const key in grouped) {
                                  filteredArray.push(
                                    grouped[key].slice(-1).pop()
                                  );
                                }
                              } else {
                                const groupedByProperty: any = _.mapValues(
                                  _.groupBy(element.readings, "propertyId")
                                );

                                const groupedByDirectionArray: any = _.map(
                                  groupedByProperty,
                                  (array) => {
                                    return _.groupBy(array, "directionId");
                                  }
                                );

                                groupedByDirectionArray.forEach(
                                  (groupedByDirection: any) => {
                                    for (const key in groupedByDirection) {
                                      filteredArray.push(
                                        groupedByDirection[key].slice(-1).pop()
                                      );
                                    }
                                  }
                                );
                              }
                              const activeDirection =
                                this.state.activeDirectionIndx.find(
                                  (elem) => elem.measurementId === element.id
                                );

                              return (
                                <td valign="top">
                                  {element.allDirections.map(
                                    (ele: any, key: number) => {
                                      const filterDatalist:any =
                                        filteredArray.filter(
                                          (elements: any) =>
                                            elements.directionId === ele.id
                                        );
                                      return (
                                        <>
                                          {filterDatalist &&
                                          filterDatalist.length ? (
                                            <span>
                                              <span
                                                style={{
                                                  cursor: "pointer",
                                                  fontWeight:
                                                    activeDirection &&
                                                    activeDirection.activeDirection.includes(
                                                      ele.id.toString()
                                                    )
                                                      ? "bold"
                                                      : "normal",
                                                  fontSize:
                                                    activeDirection &&
                                                    activeDirection.activeDirection.includes(
                                                      ele.id.toString()
                                                    )
                                                      ? "16px"
                                                      : "14px",
                                                }}
                                                onClick={() =>
                                                  this.onSetActiveDirectionIndx(
                                                    element.id,
                                                    ele.id
                                                  )
                                                }
                                              >
                                                {activeDirection &&
                                                activeDirection.activeDirection.includes(
                                                  ele.id.toString()
                                                ) ? (
                                                  <Icon
                                                    className="mr-3"
                                                    name={ABB_CARET_DOWN}
                                                  />
                                                ) : (
                                                  <Icon
                                                    className="mr-3"
                                                    name={ABB_CARET_UP}
                                                  />
                                                )}
                                                <b
                                                  style={{
                                                    marginRight: "10px",
                                                  }}
                                                >
                                                  {ele.name}
                                                </b>
                                              </span>
                                              <span>
                                                {!element.isAutoLine &&
                                                element.status?.name ===
                                                  Status.MEASURING ? (
                                                  <Button
                                                    icon={true && "abb/refresh"}
                                                    sizeClass="small"
                                                    type="primary-black"
                                                    shape={"pill"}
                                                    style={{
                                                      float: "right",
                                                      marginRight: "15px",
                                                    }}
                                                    text={t(
                                                      CONSTANTS.BUTTON_REMEASURE
                                                    )}
                                                    onClick={(e: any) =>
                                                      this.props.reMeasureDirectionPositionCount(
                                                        element.id,
                                                        ele.id,
                                                        filterDatalist &&
                                                          filterDatalist.length
                                                          ? (_.max(filterDatalist.map((x:any) => x.position)))
                                                          : null,
                                                        filterDatalist &&
                                                          filterDatalist.length
                                                          ? (_.max(filterDatalist?.filter((x:any) => x.position == _.max(filterDatalist.map((x:any) => x.position)))?.map((x:any) => x.count)))
                                                          : null
                                                      )
                                                    }
                                                  />
                                                ) : (
                                                  <></>
                                                )}
                                              </span>
                                              <div className="header-underline"></div>
                                            </span>
                                          ) : (
                                            <></>
                                          )}

                                          {activeDirection &&
                                            activeDirection.activeDirection.includes(
                                              ele.id.toString()
                                            ) &&
                                            (filterDatalist || []).map(
                                              (item: any, j: any) => {
                                                return (
                                                  <React.Fragment>
                                                    <div className="measureItems status withBg noBorder  noShadow">
                                                      <div className="details">
                                                        <p className="title">
                                                          {item?.propertyName}
                                                        </p>
                                                        <p className="subtitle" style={{wordBreak: "break-word"}}>
                                                          <strong>
                                                            {item?.value.toFixed(item.decimals)}
                                                          </strong>
                                                          &nbsp;&nbsp;
                                                          {item?.directionMeans &&
                                                          item?.directionMeans
                                                            .length ? (
                                                            item?.directionMeans.map(
                                                              (items: any) => {
                                                                if (
                                                                  item.propertyId ===
                                                                    items.propertyId &&
                                                                  item.directionId ===
                                                                    items.directionId
                                                                ) {
                                                                  return (
                                                                    <span>
                                                                      (
                                                                      {items &&
                                                                      items.mean &&
                                                                      !isNaN(
                                                                        items.mean
                                                                      ) &&
                                                                      item.hasOwnProperty("decimals") &&
                                                                      !isNaN(
                                                                        item.decimals
                                                                      )
                                                                        ? items.mean.toFixed(
                                                                            item.decimals
                                                                          )
                                                                        : CONSTANTS.NOTCONSIDEREDFORCALC}
                                                                      )
                                                                    </span>
                                                                  );
                                                                }
                                                              }
                                                            )
                                                          ) : (
                                                            <span>
                                                              {" "}
                                                              {
                                                                CONSTANTS.NOTCONSIDEREDFORCALC
                                                              }
                                                            </span>
                                                          )}
                                                          &nbsp;
                                                          {
                                                            element.properties.find((i:any) => item.propertyId === i.id && item.directionId === i.directionId).unit
                                                          }
                                                        </p>
                                                      </div>
                                                    </div>
                                                  </React.Fragment>
                                                );
                                              }
                                            )}
                                        </>
                                      );
                                    }
                                  )}
                                </td>
                              );
                            })}
                        </React.Fragment>
                      )}

                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </React.Fragment>
        )}
      </Translation>
    );
  }
}
